/** 14 juil. 09:32 / 14 Jul 09:32 — PMO's timestamp style. */
export function formatDateTime(iso: string, lang: string): string {
  const d = new Date(iso);
  return d.toLocaleDateString(lang === 'fr' ? 'fr-CH' : 'en-GB', { day: 'numeric', month: 'short' })
    + ' ' + d.toLocaleTimeString(lang === 'fr' ? 'fr-CH' : 'en-GB', { hour: '2-digit', minute: '2-digit' });
}

export function formatDate(iso: string | null | undefined, lang: string): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString(lang === 'fr' ? 'fr-CH' : 'en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function daysAgo(iso: string): number {
  return Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
}

/** "il y a 3 mois" / "il y a 2 j" — coarse, for list rows. */
export function agoLabel(iso: string | null | undefined, lang: string): string {
  if (!iso) return '—';
  const days = daysAgo(iso);
  const fr = lang === 'fr';
  if (days <= 0) return fr ? "aujourd'hui" : 'today';
  if (days === 1) return fr ? 'hier' : 'yesterday';
  if (days < 30) return fr ? `il y a ${days} j` : `${days} d ago`;
  const months = Math.floor(days / 30);
  if (months < 12) return fr ? `il y a ${months} mois` : `${months} mo ago`;
  const years = Math.floor(months / 12);
  return fr ? `il y a ${years} an${years > 1 ? 's' : ''}` : `${years} y ago`;
}

/** Just the quantity of agoLabel, no "il y a"/"ago" — for embedding in a template. */
export function agoCount(iso: string | null | undefined, lang: string): string {
  if (!iso) return '—';
  const days = daysAgo(iso);
  const fr = lang === 'fr';
  if (days <= 0) return fr ? "aujourd'hui" : 'today';
  if (days === 1) return fr ? '1 j' : '1 d';
  if (days < 30) return fr ? `${days} j` : `${days} d`;
  const months = Math.floor(days / 30);
  if (months < 12) return fr ? `${months} mois` : `${months} mo`;
  const years = Math.floor(months / 12);
  return fr ? `${years} an${years > 1 ? 's' : ''}` : `${years} y`;
}

export function parseJSON<T>(val: any, fallback: T): T {
  if (!val) return fallback;
  if (typeof val === 'object') return val as T;
  try { return JSON.parse(val) as T; } catch { return fallback; }
}
